import { businessNow } from 'helpers/businessDay'

// Периоды для фильтров аналитики — один набор на все экраны.
// Все диапазоны заканчиваются включительно; «N дней» считаются до вчера,
// чтобы незакрытый сегодняшний день не занижал средние.

export const PERIOD_PRESETS = {
	today: 'Сегодня',
	yesterday: 'Вчера',
	'7days': '7 дней',
	'14days': '14 дней',
	'30days': '30 дней',
	this_month: 'Этот месяц',
	last_month: 'Прошлый месяц',
	custom: 'Период',
}

export const DEFAULT_PRESET_IDS = ['yesterday', '7days', '30days', 'this_month', 'last_month', 'custom']

export function localDateString(date) {
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')
	return `${year}-${month}-${day}`
}

export function parseLocalDate(value) {
	return value ? new Date(`${value}T00:00:00`) : null
}

export function getPresetRange(presetId) {
	// «Сегодня» — по бизнес-дню точки: при начале дня 03:00 в 01:30 это ещё вчерашняя дата
	const today = businessNow()
	today.setHours(0, 0, 0, 0)
	const yesterday = new Date(today)
	yesterday.setDate(today.getDate() - 1)

	let start = new Date(yesterday)
	let end = new Date(yesterday)

	if (presetId === 'today') {
		start = new Date(today)
		end = new Date(today)
	} else if (presetId === '7days') {
		start.setDate(yesterday.getDate() - 6)
	} else if (presetId === '14days') {
		start.setDate(yesterday.getDate() - 13)
	} else if (presetId === '30days') {
		start.setDate(yesterday.getDate() - 29)
	} else if (presetId === 'this_month') {
		start = new Date(today.getFullYear(), today.getMonth(), 1)
		end = new Date(today)
	} else if (presetId === 'last_month') {
		start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
		end = new Date(today.getFullYear(), today.getMonth(), 0)
	}

	return { start_date: localDateString(start), end_date: localDateString(end) }
}

// Период в состоянии фильтра: { period: '7days', start_date, end_date }
export function buildPeriod(presetId) {
	return { period: presetId, ...getPresetRange(presetId) }
}

// URL отчёта из фильтра: пустое и служебное (period) не шлём, массивы — через запятую
export function buildAnalyticsUrl(url, filter, extra = {}) {
	const params = []
	Object.entries({ ...filter, ...extra }).forEach(([key, value]) => {
		if (key === 'period' || value === null || value === undefined || value === '') return
		if (Array.isArray(value)) {
			if (value.length > 0) params.push(`${key}=${encodeURIComponent(value.join(','))}`)
			return
		}
		params.push(`${key}=${encodeURIComponent(value)}`)
	})
	return params.length ? `${url}?${params.join('&')}` : url
}

export function formatPeriodLabel(startDate, endDate) {
	const start = parseLocalDate(startDate)
	const end = parseLocalDate(endDate)
	if (!start || !end) return ''
	const format = (date) => date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
	if (startDate === endDate) return format(start)
	return `${format(start)} – ${format(end)}`
}
